
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const iframeWrapper = document.querySelector("#autochat");
    const iframe = document.querySelector("#chatboxFrame");

    if (iframe) {

      var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

      var imgWrapper = iframeDocument.querySelector(".autochat_launcher");
      var img = iframeDocument.querySelector(".autochat_launcher .launcher_icon");
      var images = imgWrapper.querySelectorAll("img");

      if (img) {
        var secondImg = images[1];
        secondImg.style.position = "absolute";
         secondImg.style.top = "13%";
         secondImg.style.left = "2%";

        imgWrapper.style.background = "black";
        img.src =
          "https://cdn.shopify.com/s/files/1/0902/6602/files/chat-icon.svg?v=1716294720";
        img.style.width = "28px";
        iframeWrapper.style.display = "block";
}
    }
  }, 4000); // Задержка 500 миллисекунд


    setTimeout(function () {
    const iframeWrapper = document.querySelector("#autochat");
    const iframe = document.querySelector("#chatboxFrame");

    if (iframe) {

      var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

      var imgWrapper = iframeDocument.querySelector(".autochat_launcher");
      var img = iframeDocument.querySelector(".autochat_launcher .launcher_icon");
      var images = imgWrapper.querySelectorAll("img");


            // Создаем стиль для элемента <p>
var pStyle = document.createElement('style');
pStyle.textContent = `
    .lets-chat {
        font-family: Newsreader;
        font-size: 28.91px;
        font-style: italic;
        font-weight: 400;
        line-height: 27.18px;
        letter-spacing: -0.06em;
        text-align: left;
        color: white;
        margin: auto;
    }
`;

// Добавляем стиль внутри iframe
var iframeHead = iframeDocument.head || iframeDocument.getElementsByTagName('head')[0];
iframeHead.appendChild(pStyle);


      imgWrapper.style.width = "177px";
      var pElement = document.createElement('p');
      pElement.textContent = "Let’s Chat";
      pElement.classList.add('lets-chat');
      pElement.style=margin = "auto";
      imgWrapper.appendChild(pElement);
      imgWrapper.style.padding = "0 10px"





    }
  }, 8000); // Задержка 500 миллисекунд
});

var labelStones = document.querySelectorAll(".sorting-tab-label-stone");

function updateLabelBackgroundStone() {
  labelStones.forEach(function (input) {
    input.addEventListener("click", function () {
      console.log("sss");
      var label = this.closest(".sorting-tab-label-stone");
      if (label.style.backgroundColor === "black") {
        label.style.backgroundColor = "";
        label.style.color = "black";
      } else {
        label.style.backgroundColor = "black";
        label.style.color = "white";
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  updateLabelBackgroundStone(); // Вызываем функцию при загрузке страницы
});

function updateLabelBackground() {
  var inputs = document.querySelectorAll(".sorting-tab-input");

  inputs.forEach(function (input) {
    input.addEventListener("click", function () {
      var label = this.nextElementSibling;
      label.style.backgroundColor =
        label.style.backgroundColor === "black" ? "" : "black";
      label.style.color = label.style.color === "white" ? "black" : "white";
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  updateLabelBackground(); // Вызываем функцию при загрузке страницы
});
